import React from 'react';
import PropTypes from 'prop-types';

import Column from 'airbnb-dls-web/build/exp/Column';
import ColumnRow from 'airbnb-dls-web/build/exp/ColumnRow';

import ProjectCard from './ProjectCard';

const propTypes = {
  featuredProjectIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  projects: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default function FeaturedProjects({ featuredProjectIds, projects }) {
  const featuredProjects = featuredProjectIds.map(id =>
    projects.find(project => project.id === id),
  );

  return (
    <ColumnRow>
      {featuredProjects.slice(0, 6).map(({ id, title, stars, forks, logo, description }) => (
        <Column sm={12} md={4} key={title}>
          <ProjectCard
            id={id}
            title={title}
            logo={logo}
            description={description}
            stars={stars}
            forks={forks}
            index={projects.findIndex(node => node.id === id)}
          />
        </Column>
      ))}
    </ColumnRow>
  );
}

FeaturedProjects.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/FeaturedProjects.jsx